import BoxLoader from "../../general/boxLoader";
import EmptyBox from "../../general/emptyBox";
import React from "react";
import ExaminationCardsBoxItem from "./examinationCardsBox_Item";

type ExaminationCardsBoxProps = {
  dataList?: any;
  dataListTitles: string[];
  isRequesting: boolean
}

const ExaminationsCardsBox = ({
  dataList,
  dataListTitles,
  isRequesting
}: ExaminationCardsBoxProps) => {
  const _dataList = dataList?.data && dataList?.data.length > 0 && dataList?.data.map((item: any, i: number) => {
    return <ExaminationCardsBoxItem item={item} dataListTitles={dataListTitles} key={i}/>
  })
  return (
    <div>
      {isRequesting ? <BoxLoader/> : _dataList ? _dataList : <EmptyBox content={''} className={''} children={''}/>}
    </div>
  )
}

export default ExaminationsCardsBox;